import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VerificationComponent } from 'src/app/components/verification/verification.component';
import { PendingFileInfo } from 'src/app/components/upload-file/upload-file.component';
import { UploadCourseDocumentsComponent } from 'src/app/components/upload-course-documents/upload-course-documents.component';
import { EntityService } from 'src/app/services/entity.service';
import { formatDate as formatDateUtil } from 'src/app/utils/dates.utils';
@Component({
  selector: 'app-course-request-review',
  templateUrl: './course-request-review.component.html',
  styleUrls: [ './course-request-review.component.scss' ],
})
export class CourseRequestReviewComponent {
  @Input() course: any;
  @Input() showStatusRow: any = false;
  @Input() pendingDocuments: PendingFileInfo[] = [];
  @Input() enableDocumentUpload: boolean = false; // Enable upload button for course requests
  @Output() documentsUploaded = new EventEmitter<void>();

  showUploadDocumentsModal = false;

  constructor(
    public dialog: MatDialog,
    private entityService: EntityService,
  ) {}

  formatDate(date: any): string {
    const timezone = this.entityService.getLocalTimezone();
    return formatDateUtil.asDateWithTimezone(date, timezone);
  }

  formatTime(timeString: string): string {
    if (!timeString) return '';
    
    // Handle "Anytime" case
    if (timeString === 'Anytime') return 'Anytime';

    if (timeString.includes('AM') || timeString.includes('PM')) return timeString;
    
    // Parse 24-hour format (HH:MM) and convert to 12-hour format with AM/PM
    const [hours, minutes] = timeString.split(':');
    if (!hours || !minutes) return timeString;
    
    const hour24 = parseInt(hours, 10);
    const hour12 = hour24 % 12 || 12;
    const ampm = hour24 >= 12 ? 'PM' : 'AM';
    
    return `${hour12}:${minutes} ${ampm}`;
  }

  viewReason() {
    this.dialog.open(VerificationComponent, {
      data: {
        title: 'Reason for Denial',
        text: this.course?.statusComments,
        icon: 'info',
        confirmButtonTitle: 'Ok',
      },
    });

  }

  getCourseItemId(): number | null {
    // Priority: courseItemId > CourseItems[0].id > id (but only if it's not the courseId)
    if (this.course?.courseItemId) {
      return Number(this.course.courseItemId);
    }
    if (this.course?.CourseItems) {
      if (Array.isArray(this.course.CourseItems) && this.course.CourseItems.length > 0) {
        return Number(this.course.CourseItems[0].id);
      }
      if (typeof this.course.CourseItems === 'object') {
        return Number(this.course.CourseItems.id);
      }
    }
    // Only use id if it's not the same as courseId (to avoid using courseId instead of courseItemId)
    if (this.course?.id && this.course?.id !== this.course?.courseId) {
      return Number(this.course.id);
    }
    if (this.course?.course_item_id) {
      return Number(this.course.course_item_id);
    }
    return null;
  }


  openUploadDocumentsModal(): void {
    this.showUploadDocumentsModal = true;
  }

  closeUploadDocumentsModal(): void {
    this.showUploadDocumentsModal = false;
  }

  onDocumentsUploaded(): void {
    // Trigger reload of course data to refresh documents after upload
    this.documentsUploaded.emit();
  }

  onDocumentDeleted(): void {
    // Trigger reload of course data to refresh documents after deletion
    this.documentsUploaded.emit();
  }

}
